import { FullScreenContainer, Spinner } from "@components/ui-kit";
import { BudgetovacIframe } from "@components/widgets/BudgetovacIframe";
import { NotAllowedPage } from "@components/widgets/NotAllowedPage";
import { t } from "@lingui/macro";
import { useProjectForBudgetsQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { getQueryParamOptional } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";

interface BudgetsProps {
  /** Project.id */
  id: string;
}

const Budgets = ({ id }: BudgetsProps) => {
  const { query } = useRouter();
  const { data, loading } = useProjectForBudgetsQuery({
    variables: { id },
    ...onError(),
  });

  if (loading) {
    return <Spinner absolute />;
  }

  if (!data?.project) return null;

  if (!data.project.uses_budgetovac) {
    return (
      <NotAllowedPage
        title={t`Budget page is not allowed for this project.`}
        link={{
          href: { pathname: "/projects/budget", query: { id } },
          content: t`Go to BUDGET`,
        }}
      />
    );
  }

  return (
    <FullScreenContainer noBottomMargin>
      <BudgetovacIframe
        page="budgets"
        embedded
        showMenu={false}
        proposals={!data.project.budgetovacBudget?.budget_id}
        projectId={data.project.id}
        clientId={data.project.brand.id}
        budgetId={getQueryParamOptional("budget_id", query)}
      />
    </FullScreenContainer>
  );
};

export default observer(Budgets);
